import { useEffect, useReducer } from 'react';

export default function useLoadApplePaySDK() {
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  useEffect(() => {
    function onLoad() {
      forceUpdate();
    }

    let script: HTMLScriptElement;

    function loadApplePaySDK() {
      const src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

      const existing = document.querySelector(`script[src="${src}"]`);

      if (!existing) {
        script = document.createElement('script');
        script.setAttribute('crossorigin', '');
        script.src = src;
        script.async = true;
        script.addEventListener('load', onLoad);
        document.body.appendChild(script);
      }
    }

    if (!window.ApplePaySDK) {
      loadApplePaySDK();
    }

    return () => {
      if (script) {
        script.removeEventListener('load', onLoad);
      }
    };
  }, []);

  return typeof window !== 'undefined' && typeof window.ApplePaySDK !== 'undefined';
}
